import { NgModule } from '@angular/core';

import { provideConfig } from '@spartacus/core';

@NgModule({
  providers: [
    provideConfig({
      featureModules: {
        sanitizeParagraphFeature: {
          cmsComponents: ['DpHTMLParagraphComponent'],
          module: () => import('./sanitized-paragraph').then((m) => m.DpSanitizedParagraphModule)
        },
        paragraphFeature: {
          cmsComponents: ['CMSParagraphComponent', 'CMSTabParagraphComponent'],
          module: () => import('./paragraph').then((m) => m.DpParagraphModule)
        },
        complexParagraphFeature: {
          cmsComponents: ['DpComplexParagraphComponent'],
          module: () => import('./complex-paragraph').then((m) => m.DpComplexParagraphModule)
        },
        surchargeParagraphFeature: {
          cmsComponents: ['SurchargeParagraphComponent'],
          module: () => import('./surcharge-paragraph').then((m) => m.DpSurchargeParagraphModule)
        }
      }
    })
  ]
})
export class DpParagraphFeatureModule {}
